<template>
    <div>
        <p class="text-small text-primary font-weight-medium mb-3" v-if="showTitle">
            <v-icon class="me-2" color="secondary" size="20">icon-chart</v-icon>فراوانی تیکت‌ها
        </p>
        <v-skeleton-loader v-if="skeleton" class="mx-auto" height="350" type="ossein"></v-skeleton-loader>
        <apexchart
            :options="chartOptions"
            :series="series"
            height="350"
            v-else
        ></apexchart>
    </div>
</template>
<script>
import fa from "apexcharts/dist/locales/fa.json";
import VueApexCharts from "vue3-apexcharts";
export default {
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        showTitle: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            skeleton: true,
            series: [],
            chartOptions: {
                chart: {
                    locales: [fa],
                    defaultLocale: "fa",
                    stacked: true,
                    type: "line",
                    zoom: {
                        type: "x",
                        enabled: true,
                        autoScaleYaxis: true,
                    },
                },
                grid: {
                    row: {
                        colors: ["#f3f3f3", "transparent"],
                        opacity: 0.5,
                    },
                },
                tooltip: {
                    style: {
                        fontFamily: "iransans",
                    },
                    x: {
                        format: "d MMMM",
                    },
                },
                markers: {
                    size: 5,
                },
                xaxis: {
                    type: "datetime",
                    labels: {
                        datetimeUTC: false,
                        datetimeFormatter: {
                            year: "yyyy",
                            month: "MMMM",
                            day: "M/dd",
                            hour: "HH:mm",
                        },
                        style: {
                            fontFamily: "iransans",
                        },
                    },
                    tooltip: {
                        enabled: false,
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            fontFamily: "iransans",
                        },
                    },
                },
            },
            search: {},
        };
    },
    methods: {
        reportTicketFrequencyFilter(search) {
            this.skeleton = true;
            this.search = { ...search };
            this.reportTicketFrequencyGet();
        },
        reportTicketFrequencyGet() {
            this.$reportTicketFrequency(
                this.$route.path !== "/report"
                    ? { from_date: this.$moment().subtract(1, "years").unix() }
                    : this.search
            ).then((res) => {
                if (res && res.status == "OK") {
                    this.series = [];
                    this.series.push({
                        data: res.data.map((item) => {
                            return {
                                x: this.$moment(item.x).format('jYYYY/jMM/jDD'),
                                y: item.y,
                            };
                        }),
                        name: "تعداد تیکت",
                    });
                    this.skeleton = false;
                }
            });
        },
    },
    mounted() {
        this.reportTicketFrequencyGet();
    },
};
</script>
